import type { NavbarComponent } from "../../_types";

/**
 * Creates a default navbar component (visible by default). Shared by the builder store
 * (backfilling a navbar into layout_trees that predate the component, or that a user adds
 * manually) and `createSubpage` (seeding a new subpage's initial layout_tree) so both call
 * sites construct the same placeholder shape from one source of truth.
 * @returns A new navbar component with default styling.
 */
export function createDefaultNavbar(): NavbarComponent {
  return {
    id: crypto.randomUUID(),
    type: "navbar",
    title: "Navbar",
    visible: true,
    ctaButtons: [{ id: crypto.randomUUID(), label: "Register", url: "" }],
  };
}
